export * from './src/email-marketing-v1-campaign-campaigns.meta.js';
